export default "__VITE_ASSET__eAQWMx5T__"